import { defineComponent as _defineComponent } from 'vue'
import { onClickOutside, templateRef } from '@vueuse/core';
import { computed } from 'vue';
import NotificationPanel from '@/components/toolbar/notification/NotificationPanel.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import useNotificationState from '@/state/notificationState';
import { NotificationType } from '@/models/Notification';
import NotificationBar from './NotificationBar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  setup(__props) {

const { isSmartphoneWidth } = useResponsiveness();
const {
  whichPanel, showPanel, panelPos
} = useNotificationState();

const active = computed(() => (isSmartphoneWidth.value && showPanel.value ? whichPanel.value : ''));

const togglePanel = (which: NotificationType | '', pos:number) => {
  if (isSmartphoneWidth.value) {
    panelPos.value = pos;
    showPanel.value = whichPanel.value === which ? !showPanel.value : true;
  } else {
    showPanel.value = !showPanel.value;
  }
  whichPanel.value = which;
};

const clickOutside = () => {
  showPanel.value = false;
};

onClickOutside(templateRef<HTMLElement>('notification'), () => clickOutside());

return { __sfc: true,isSmartphoneWidth, whichPanel, showPanel, panelPos, active, togglePanel, clickOutside, NotificationPanel, NotificationBar }
}

})